import { Filter } from '@anytag/shared-molecules';
import { usePostsInsightFilter } from './hooks';
import { Template, TemplateProps } from './Template';

export type PostsInsightFilterProps = Omit<TemplateProps, 'onSubmit'>;

export const PostsInsightFilter = (props: PostsInsightFilterProps) => {
  const { filter, setFilterForm } = usePostsInsightFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="px-4 py-2">
      <Template {...props} />
    </Filter.Provider>
  );
};

export { usePostsInsightFilter };
export * from './schemaTypes';
